<template>
    <div class="">
        <div v-if="this.$route?.name == 'ConsultaCausacion'"> 
            <div class="col-md-12 mt-3">
                <h2> {{ labels.title }} </h2> 
            </div>
            <div class="row mt-5">
                <div class="col-md-6 d-flex justify-content-end">
                    <h4>{{ labels.fechaCausacion }}</h4> 
                </div>
                <div class="col-md-2 d-flex justify-content-start">
                    <input type="month" :items="fechaCausacion" class="form-control">
                </div>
            </div>
            <div class="col-md-12 mt-4">
                <b-button type="button" id="create-btn" @click="procesarCausacion">{{ labels.consultar }}</b-button> 
            </div>
        </div>
        <div class="col-md-12 mt-3">
            <div v-if="btnGenExcel" class="row col-md-12 align-items-center d-flex justify-content-end">
                <b-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaExcelCausacion()">
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg> 
                    </i>
                </b-button>
            </div>
            <div class="row col-md-12 justify-content-center" v-if="listCausacion != 0">
                <b-table md-card md-header :items="listCausacion">
                    <b-table-row slot="b-table-row" slot-scope="{ item }">
                        <b-table-cell :md-label="labels.nroContrato" class="border">{{ item?.nro_contrato }}</b-table-cell> 
                        <b-table-cell :md-label="labels.fecha" class="border">{{ item?.fecha_causacion }}</b-table-cell> 
                        <b-table-cell :md-label="labels.totalValorCanon" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.total_valor_canon) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.totalPasivoInicial" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.total_pasivo_inicial) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.totalCambioPasivo" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.total_cambio_pasivo) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.totalGastoAmortizacion" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.total_gasto_amortizacion) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.totalIntereses" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.total_intereses) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.totalPasivoFinal" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.total_pasivo_final) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.totalActivoDerUsoBruto" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.total_activo_derecho_uso_bruto) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.totalPagoCapital" class="border">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.total_pago_capital) }}</b-table-cell> 
                    </b-table-row>
                </b-table>
            </div>
            <div v-else>
                <div v-if="this.$route?.name == 'ConsultaCausacion'"> 
                    <h5>{{ labels.noRow }}</h5> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as XLSX from "exceljs";
import ContratoCausacion from '../../services/ContratoCausacion'; 
export default {
    name : 'ConsultaCausacion',
    props : ['listCausacion'],
    data: () => ({
        fechaCausacion : '',
        btnGenExcel : false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Consulta causación',
                    fechaCausacion : 'Fecha causación:',
                    fecha : 'Fecha causación',
                    consultar : 'Consultar',
                    nroContrato : 'Nro. contrato', 
                    totalValorCanon : 'Total valor canon',
                    totalPasivoInicial : 'Total pasivo inicial',
                    totalCambioPasivo : 'Total cambio pasivo',
                    totalPagoCapital : 'Total pago capital',
                    totalIntereses : 'Total intereses',
                    totalPasivoFinal : 'Total pasivo final',
                    totalActivoDerUsoBruto : 'Total activo derecho de uso bruto',
                    totalGastoAmortizacion : 'Total gasto amortización',
                    noRow : 'No hay registros'
                }
            }else{
                return {
                    title : 'Causation consultation',
                    fechaCausacion : 'Causation date:',
                    fecha : 'Causation date',
                    consultar : 'Consult',
                    nroContrato : 'Contract Num.', 
                    totalValorCanon : 'Total canon value',
                    totalPasivoInicial : 'Total initial liabilities',
                    totalCambioPasivo : 'Total passive change',
                    totalPagoCapital : 'Total capital payment',
                    totalIntereses : 'Total interests',
                    totalPasivoFinal : 'Total final liabilities',
                    totalActivoDerUsoBruto : 'Total gross right-of-use assets',
                    totalGastoAmortizacion : 'Total amortization expense',
                    noRow : 'There are no records'
                }
            }
        }
    },
    methods:{
        procesarCausacion(){
            if(this.fechaCausacion != ''){ 

                ContratoCausacion.getCausacionByFecha(this.fechaCausacion) 
                .then((res) => { 
                    // console.log(res.data.listContratosCausados); 
                    this.listCausacion = res.data.listContratosCausados 

                    if(this.listCausacion.length != 0){ 
                        this.btnGenExcel = true 
                    }else{
                        this.btnGenExcel = false 
                    }
                })
                .catch((err) => console.log(err)) 

            }else{
                this.$toast.error('Diligenciar la fecha.') 
            }
        },
        async generaExcelCausacion(){

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Causación "+this.fechaCausacion) 

            const titulo = ["Causación - vigencia "+this.fechaCausacion] 
            worksheet.addRow(titulo) 
            worksheet.mergeCells('A1:J1') 
            worksheet.getCell('A1').font = { bold : true, size : 12}; 
            worksheet.getCell('A1').alignment = { horizontal : 'center'}; 

            const tituloCelda = [
                'Nro. contrato', 
                'Fecha causación',
                'Total valor canon',
                'Total pasivo inicial',
                'Total cambio pasivo',
                'Total gasto amortización',
                'Total intereses',
                'Total pasivo final',
                'Total activo derecho de uso bruto',
                'Total pago capital'
            ]
            worksheet.addRow(tituloCelda) 
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = { 
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.listCausacion.map((e) => { 
                worksheet.addRow([ 
                    e.nro_contrato, 
                    e.fecha_causacion, 
                    parseFloat(e.total_valor_canon), 
                    parseFloat(e.total_pasivo_inicial), 
                    parseFloat(e.total_cambio_pasivo), 
                    parseFloat(e.total_gasto_amortizacion), 
                    parseFloat(e.total_intereses), 
                    parseFloat(e.total_pasivo_final), 
                    parseFloat(e.total_activo_derecho_uso_bruto), 
                    parseFloat(e.total_pago_capital) 
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){ 
                for( let col = 1; col <= worksheet.columnCount; col++){ 
                    worksheet.getCell(row, col).border = border; 
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer() 
            const downloadLink = document.createElement("a") 
            downloadLink.download = "Causación "+this.fechaCausacion+".xlsx" 
            downloadLink.href = window.URL.createObjectURL( 
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
                })
            )

            downloadLink.style.display = "none"; 

            document.body.appendChild(downloadLink); 
            downloadLink.click(); 

            downloadLink.remove(); 
        }
    },
    // mounted(){
    // console.log(this.$route.name,'AAA'); 
    // }
}
</script>

<style>

</style>
